import { Action } from '@ngrx/store';

export enum PageAlertActionTypes {
  GetPageAlert = '[Page Alert] Get Page Alert',
  NoOpAction = '[Page Alert] Do Nothing',
}

export class GetPageAlert implements Action {
  readonly type = PageAlertActionTypes.GetPageAlert;

  constructor(public page: string) {}
}

export class NoOpAction implements Action {
  readonly type = PageAlertActionTypes.NoOpAction;
}
